/**
 * Message types for token synchronization between tabs and shared worker
 */

export interface UserTokens {
    access_token: string;
    expires_in: number;
    refresh_token: string;
    token_type: string;
    share_token?: string;
}

export enum TokenSyncMessageType {
    // Client -> Worker messages
    SET_TOKENS = 'SET_TOKENS',
    GET_TOKENS = 'GET_TOKENS',
    CLEAR_TOKENS = 'CLEAR_TOKENS',
    TOKEN_REFRESHED = 'TOKEN_REFRESHED',

    // Worker -> Client messages
    TOKENS_UPDATED = 'TOKENS_UPDATED',
    TOKENS_RESPONSE = 'TOKENS_RESPONSE',
    TOKENS_CLEARED = 'TOKENS_CLEARED'
}

export interface TokenSyncMessage {
    type: TokenSyncMessageType;
    payload?: UserTokens;
    requestId?: string;
}

export interface TokenSyncPort {
    onmessage: ((event: MessageEvent<TokenSyncMessage>) => void) | null;
    postMessage: (message: TokenSyncMessage) => void;
    start?: () => void;
}
